var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import ReactModal from 'react-modal';
import theme from '../../theme';
function _getStyles(style) {
    return {
        overlay: __assign({ display: theme.style.display.flex, justifyContent: theme.style.justifyContent.center, alignItems: theme.style.alignItems.center, backgroundColor: '#000000a6', zIndex: 1000 }, style === null || style === void 0 ? void 0 : style.overlay),
        content: __assign({ position: 'relative', top: 'auto', left: 'auto', bottom: 'auto', right: 'auto', maxWidth: '90%', maxHeight: '90%', padding: 0, borderWidth: theme.typography.border.width.xxxThin, borderStyle: theme.typography.border.style.solid, borderRadius: theme.typography.border.radius.xSmall, borderColor: theme.colors.tfwBlack12 }, style === null || style === void 0 ? void 0 : style.content),
    };
}
var Modal = function (_a) {
    var children = _a.children, style = _a.style, restProps = __rest(_a, ["children", "style"]);
    var modalStyles = useMemo(function () {
        return _getStyles(style);
    }, [style]);
    return (React.createElement(ReactModal, __assign({ style: modalStyles, shouldCloseOnEsc: true, shouldCloseOnOverlayClick: true }, restProps), children));
};
export default Modal;
